exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".address1{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-add/vendor-add.component.css"],"names":[],"mappings":"AAAA,UACI,kBAAA,cAAe,cACC,CACjB","file":"vendor-add.component.css","sourcesContent":[".address1 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-add/vendor-add.component.css
// module id = TAjX
// module chunks = 0